import { Directive, ChangeDetectorRef, HostListener } from '@angular/core';

/**
 * Global fix for Action dropdown not opening on first click (change detection).
 * Add to the same element that has (click)="toggleActionDropdown(...)".
 * Schedules change detection after the click so the dropdown state is rendered.
 */
@Directive({
  selector: '[appActionDropdownTrigger]',
  standalone: true,
})
export class ActionDropdownTriggerDirective {
  constructor(private cdr: ChangeDetectorRef) {}

  @HostListener('click')
  onHostClick(): void {
    setTimeout(() => this.cdr.detectChanges(), 0);
  }
}
